import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";
import App from "./app/app";

const appContainer = document.getElementById("root");
// if (!Utilities.isNullObject(appContainer)) {
ReactDOM.render(<App />, appContainer);
// }
